import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=45043747&"
import script from "./Breadcrumb.vue?vue&type=script&lang=js&"
export * from "./Breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45043747')) {
      api.createRecord('45043747', component.options)
    } else {
      api.reload('45043747', component.options)
    }
    module.hot.accept("./Breadcrumb.vue?vue&type=template&id=45043747&", function () {
      api.rerender('45043747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Breadcrumb.vue"
export default component.exports